export const routesConfig = {
  LOGIN: "/login",
  HOME: "/home",
  ORDERS: "/ordens",
  NEW_ORDERS: "/nova-ordem"
};
